import React, { useEffect, useRef, useState } from "react";

const bannerImages = [
  require("../assets/Banner/four.point_.adventures.1600x800.jpg"),
  require("../assets/Banner/heritage.inspirations.1600x800.jpg"),
  require("../assets/Banner/jackson.hole_.paragliding.1600x800.jpg"),
  require("../assets/Banner/moondance.sea_.kayak_.adventrues.1600x800.jpg"),
  require("../assets/Banner/seattle.mountain.bike_.tours_.1600x800.jpg"),
  require("../assets/Banner/teton.backcountry.rentals.1600x800.jpg"),
];

export default function BannerCarousel() {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef();

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setIndex((prev) => (prev + 1) % bannerImages.length);
    }, 10000);
    return () => clearTimeout(timeoutRef.current);
  }, [index]);

  return (
    <div className="relative w-full max-w-full sm:max-w-2xl h-48 sm:h-64 md:h-80 overflow-hidden rounded-2xl shadow-xl mb-6 sm:mb-8">
      {/* Overlayed text */}
      <div className="absolute bottom-0 left-0 right-0 z-20 flex flex-col items-center justify-end text-center px-4 pb-4">
        <h2 className="text-lg sm:text-2xl md:text-3xl font-bold text-white drop-shadow-lg mb-2" style={{fontFamily: 'Times New Roman, Times, serif', fontSize: '2.5em', textShadow:'0 2px 8px rgba(0,0,0,0.7)'}}>Small Business, Big Adventures</h2>
        <p className="text-xs sm:text-base md:text-lg text-white font-medium drop-shadow-lg" style={{textShadow:'0 2px 8px rgba(0,0,0,0.7)'}}>Explore our curated selection of outdoor guides, outfitters, rentals and more.</p>
      </div>
      {bannerImages.map((src, i) => (
        <img
          key={i}
          src={src}
          alt={`Banner ${i + 1}`}
          className={`absolute top-0 left-0 w-full h-full object-cover transition-transform duration-700 ease-in-out ${
            i === index ? "translate-x-0 z-10 opacity-100" : "translate-x-full z-0 opacity-0"
          }`}
          style={{ transitionProperty: "transform, opacity" }}
        />
      ))}
    </div>
  );
}
